document.addEventListener('DOMContentLoaded', function() {
  const paragraphs = document.querySelectorAll('.desc-box .paragraph');
  
  paragraphs.forEach(function(paragraph) {
    const readMoreBtn = paragraph.nextElementSibling;
    if (!readMoreBtn || !readMoreBtn.classList.contains('read-more')) return;
    
    // Get the line height of the paragraph
    const lineHeight = parseInt(window.getComputedStyle(paragraph).lineHeight);
    // Calculate max height for 3 lines
    const maxHeight = lineHeight * 3;
    
    // Check if content height exceeds 3 lines
    if (paragraph.scrollHeight > maxHeight) {
      // Show the read more button only if content is truncated
      readMoreBtn.style.display = 'inline-block';
      
      // Add click event listener to toggle button
      readMoreBtn.addEventListener('click', function() {
        paragraph.classList.toggle('expanded');
        readMoreBtn.textContent = paragraph.classList.contains('expanded') ? 'read less' : 'read more';
      });
    } else {
      // Content fits within 3 lines, keep "read more" hidden
      readMoreBtn.style.display = 'none';
    }
  });
});